import gsap from "gsap";
import AudioManager from "scripts/util/AudioManager";
import AssetLoader from "../loaders/AssetLoader";
import * as BABYLON from "babylonjs";
import RootObjects from "./RootObjects";
// import Main from "scripts/3d/experience/Main";

const LANE_AMOUNT = 2.5;
const GRAVITY = 0.012;
const JUMP_VELOCITY = 0.23;
const SCALE = 1.25;
const SCALE_YETI = 1.15;

class Sled {
  constructor(character, type, scene, VFX) {
    this.view = new BABYLON.TransformNode("sled");
    this.type = type;
    this.VFX = VFX;
    this.snowball = null;
    this.isSnowball = false;

    this.snowballTemplate = AssetLoader.getContainer("Snowball");
    this.snowballTemplate.rootNodes[0].getChildMeshes().forEach((mesh)=> {
      mesh.isPickable = false;
    })
    
    this.character = character.meshes[0];
    this.character.parent = this.view;
    this.character.scaling =
      this.type === "yeti"
        ? new BABYLON.Vector3(SCALE_YETI, SCALE_YETI, -SCALE_YETI)
        : new BABYLON.Vector3(SCALE, SCALE, -SCALE);

    this.objectKey = this.type === "bear" ? "Object" : "Obstacle";

    this.animations = character.animations;
    this.animations["Start"].start(false).pause().goToFrame(0);

    this.scene = scene;

    this.lane = 0;
    this.character = 0;
    this.animating = false;
    this.jumping = false;
    this.moving = false;
    this.velocity = 0;

    this.collider = BABYLON.MeshBuilder.CreateBox("SledCollider", {
      width: 0.4,
      height: 1,
      depth: 1.5,
    });
    this.collider.parent = this.view;
    this.collider.position.y = 0.55;
    this.collider.position.z = -0.2;
    this.collider.isPickable = false;
    this.collider.isVisible = false;

    this.target = BABYLON.MeshBuilder.CreateBox("SLED-CAMERA-TARGET", { size: 0.1 });
    this.target.position.y = 1;
    this.target.isVisible = false;
    this.target.parent = this.view;

    this.leftRay = new BABYLON.Ray(
      new BABYLON.Vector3(0, 0.5, 0),
      new BABYLON.Vector3(1, 0, -1),
      3.5
    );
    this.rightRay = new BABYLON.Ray(
      new BABYLON.Vector3(0, 0.5, 0),
      new BABYLON.Vector3(-1, 0, -1),
      3.5
    );

    this.particleSystem = new BABYLON.ParticleSystem(
      "snowball-particles",
      200
    );
    this.particleSystem.stop();
    this.particleSystem.particleTexture = AssetLoader.getTexture('Snow')

    this.particleSystem.emitter = new BABYLON.Vector3(0, .25, 0);
    var emitterType = new BABYLON.SphereParticleEmitter();
    emitterType.radius = 0.3;
    emitterType.radiusRange = 0;

    this.particleSystem.particleEmitterType = emitterType;

    // Colors of all particles
    // this.particleSystem.color1 = new BABYLON.Color4(0.53, 0.91, 0.98);
    // this.particleSystem.color2 = new BABYLON.Color4(1, 1, 1);

    // Size of each particle (random between...
    this.particleSystem.minSize = 0.1;
    this.particleSystem.maxSize = 0.5;

    // Life time of each particle (random between...
    this.particleSystem.minLifeTime = 0.75;
    this.particleSystem.maxLifeTime = 1.25;

    // Blend mode : BLENDMODE_ONEONE, or BLENDMODE_STANDARD
    this.particleSystem.blendMode = BABYLON.ParticleSystem.BLENDMODE_ADD;
    this.particleSystem.billboardMode = BABYLON.AbstractMesh.BILLBOARDMODE_ALL;

    // Set the gravity of all particles
    this.particleSystem.gravity = new BABYLON.Vector3(0, 1, 0);

    // Angular speed, in radians
    this.particleSystem.minAngularSpeed = 0;
    this.particleSystem.maxAngularSpeed = Math.PI;

    // Speed
    this.particleSystem.minEmitPower = 1;
    this.particleSystem.maxEmitPower = 2;
    this.particleSystem.updateSpeed = 0.025;

    this.starParticleSystem = new BABYLON.GPUParticleSystem(
      "characterStarParticles",
      20
    );
    this.starParticleSystem.particleTexture = AssetLoader.getTexture("PresentSparks");
    this.starParticleSystem.startSpriteCellID = 0;
    this.starParticleSystem.spriteCellHeight = 128;
    this.starParticleSystem.spriteCellWidth = 128;
    this.starParticleSystem.spriteRandomStartCell = true;
    this.starParticleSystem.isAnimationSheetEnabled = true;
    this.starParticleSystem.minLifeTime = 0.2;
    this.starParticleSystem.maxLifeTime = 1.2;
    this.starParticleSystem.emitRate = 8;
    this.starParticleSystem.minEmitPower = 1;
    this.starParticleSystem.maxEmitPower = 5;
    this.starParticleSystem.isLocal = true;
    this.starParticleSystem.minSize = 0.4;
    this.starParticleSystem.maxSize = 0.6;
    this.starParticleSystem.color1 = new BABYLON.Color4(1, 1, 1, 0);
    this.starParticleSystem.color2 = new BABYLON.Color4(1, 1, 1, 1);
    this.starParticleSystem.colorDead = new BABYLON.Color4(1, 1, 1, 0);
    this.starParticleSystem.blendMode = BABYLON.ParticleSystem.BLENDMODE_ADD;
    this.starParticleSystem.particleEmitterType.directionRandomizer = 1;
    this.starParticleSystem.direction1 = new BABYLON.Vector3(0.2, 0.5, 0);
    this.starParticleSystem.direction2 = new BABYLON.Vector3(-0.2, 0.5, 0);
    this.starParticleSystem.billboardMode = BABYLON.AbstractMesh.BILLBOARDMODE_ALL;
    this.meshEmitter = BABYLON.MeshBuilder.CreateBox("starEmitterBox", {
      height: 0.05,
      width: 0.05,
      depth: 0.05,
    });
    this.meshEmitter.position.y = 0.6;
    this.collider.addChild(this.meshEmitter);
    this.meshEmitter.isVisible = false;
    this.meshEmitter.isBlocker = false;
    this.starParticleSystem.emitter = this.meshEmitter;
    this.starParticleSystem.stop();
    this.starParticleSystem.parent = this.collider;

    // BABYLON.RayHelper.CreateAndShow(this.leftRay, scene, new BABYLON.Color3(1, 0, 0));
    // BABYLON.RayHelper.CreateAndShow(this.rightRay, scene, new BABYLON.Color3(1, 0, 0));
  }

  intro() {
    const aGroup = this.animations["Start"];
    aGroup.onAnimationGroupEndObservable.addOnce(() => {
      this.animations["Idle"].start(true);
      this.VFX.introComplete = true;
      this.VFX.startSledSnow();
    });
    aGroup.play();
  }

  showCharacter(character) {
    this.character = character;
  }

  startStarPower() {
    this.starParticleSystem.start();
  }

  stopStarPower() {
    this.starParticleSystem.stop();
  }

  startSnowball() {

    this.isSnowball = true;

    this.goodCollider = BABYLON.MeshBuilder.CreateBox("goodCollider", {
      width: 6,
      height: 5,
      depth: 1.5,
    });
    this.goodCollider.parent = this.view;
    this.goodCollider.position.y = 0.55;
    this.goodCollider.position.z = -0.4;
    this.goodCollider.isPickable = false;
    this.goodCollider.isVisible = false;

    gsap.to(RootObjects.getObject('camera'), { duration: 0.3, radius: 12, heightOffset: 5 });
    this.snowball = this.snowballTemplate.instantiateModelsToScene((name) => "SB_" + name);
    this.snowball.rootNodes[0].scaling = new BABYLON.Vector3(0, 0, 0);
    gsap.to(this.snowball.rootNodes[0].scaling , { x: 5.5, y: 5.5, z:-5.5 });


    //yeti
    this.snowball.rootNodes[0].position.y = -.25;
    if(this.type == 'yeti') {
      this.snowball.rootNodes[0].position.z = .3;
    }

    this.snowball.animationGroups[0].start(true, 1, 0);
    this.snowball.rootNodes[0].parent = this.view;
  }

  stopSnowball(newParent) {

    this.isSnowball = false;

    this.goodCollider.parent = null;
    this.goodCollider.isVisible = false;
    this.goodCollider.dispose();

    this.particleSystem.manualEmitCount = 3000;
    this.particleSystem.start();

    gsap.to(RootObjects.getObject('camera'), { duration: 0.3, radius: 5, heightOffset: 1 });

    this.snowball.animationGroups[0].stop();
    this.snowball.rootNodes[0].getChildMeshes()[0].isVisible = false;
    this.snowball.rootNodes[0].setParent(newParent);
    this.snowball.animationGroups[1].start(false, 1, 0);

    const tempSnowball = this.snowball
    this.snowball = null
    setTimeout(() => {
      tempSnowball.dispose();
    }, 2000);
  }

  hit() {
    this.animations[`Hit_${this.objectKey}_Front`].play();
  }

  changeLane(direction) {
    if ((direction === -1 && this.lane > -2) ||(direction === 1 && this.lane < 2)) {
      
      var hit = this.scene.pickWithRay(direction === -1 ? this.leftRay : this.rightRay)
      console.log('HIT', hit)
      
      var meshName = ''
      if(hit.pickedMesh && hit.pickedMesh.name) {
        meshName = hit.pickedMesh.name
        console.log('Picked Mesh', hit.pickedMesh.name)
      }

      if (meshName === '' || meshName.includes("Pressent")) {
        this.lane += direction;
        this.leftRay.origin.x = this.rightRay.origin.x = -LANE_AMOUNT * this.lane;
        gsap.to(this.view.position, {
          duration: 0.5,
          x: -LANE_AMOUNT * this.lane,
        });
        const key = direction === 1 ? "Turn_Right" : "Turn_Left";
        this.animations[key].play();
      } else {
        if (this.moving) return;
        const key =direction === 1
            ? `Hit_${this.objectKey}_Right`
            : `Hit_${this.objectKey}_Left`;
        this.animations[key].pause().goToFrame(0).play();
        const current = -LANE_AMOUNT * this.lane;
        this.moving = true;
        gsap.to(this.view.position, {
          duration: 0.25,
          x: current - direction * 1,
          ease: "power2.in",
          onComplete: () => {
            AudioManager.playSound("hit");
          },
        });
        gsap.to(this.view.position, {
          duration: 0.25,
          delay: 0.25,
          x: current,
          ease: "power2.out",
          onComplete: () => (this.moving = false),
        });
      }
    } else {
      if (this.moving) return;
      const key =
        direction === 1
          ? `Hit_${this.objectKey}_Right`
          : `Hit_${this.objectKey}_Left`;
      this.animations[key].pause().goToFrame(0).play();
      const current = -LANE_AMOUNT * this.lane;
      this.moving = true;
      gsap.to(this.view.position, {
        duration: 0.25,
        x: current - direction * 1,
        ease: "power2.in",
        onComplete: () => {
          AudioManager.playSound("hit");
        },
      });
      gsap.to(this.view.position, {
        duration: 0.25,
        delay: 0.25,
        x: current,
        ease: "power2.out",
        onComplete: () => (this.moving = false),
      });
    }
  }

  hitIcePatch() {
    this.animations["Turn_Right"].play();
    setTimeout(() => {
      this.animations["Turn_Left"].play();
    }, 400);
  }

  jump() {
    if (this.jumping) return;
    this.jumping = true;
    this.velocity = JUMP_VELOCITY;
    this.animations["Jump"].play();
    AudioManager.playSound("jump");
    this.VFX.stopSledSnow();
  }


  bounce() {
    this.velocity = JUMP_VELOCITY;
    this.animations["Jump"].pause().goToFrame(0).play();
    AudioManager.playSound("jumpLand");
  }

  xpos() {
    return this.view.position.x;
  }
  ypos() {
    return this.view.position.y;
  }

  update() {
    const ratio = this.scene.getAnimationRatio()
    this.velocity -= GRAVITY * ratio
    this.view.position.y += this.velocity * ratio;
    if (this.view.position.y <= 0) {
      if(this.jumping) {
        AudioManager.playSound("jumpLand");
        this.jumping = false;
        this.VFX.beginSledSnow();
      }
      this.view.position.y = 0;
      this.velocity = 0;
    }
  }
}

export default Sled;
